import { render, staticRenderFns } from "./HomePrescriber.vue?vue&type=template&id=81aedf9e&scoped=true&"
import script from "./HomePrescriber.vue?vue&type=script&lang=ts&"
export * from "./HomePrescriber.vue?vue&type=script&lang=ts&"
import style0 from "./HomePrescriber.vue?vue&type=style&index=0&id=81aedf9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81aedf9e",
  null
  
)

export default component.exports